import type { StoreProvider } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";

export class ProvidersSectionState {
  readonly providers = new RxList<StoreProvider>();
  /** Loading until the providers have answered once for this shop; the shell's later refreshes do not flip it back. */
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly connectingKey = new Rx<string | null>(null);
  readonly refreshingKey = new Rx<string | null>(null);
  readonly disconnectingKey = new Rx<string | null>(null);
  readonly dashboardBusy = new Rx(false);
  readonly confirmingDisconnect = new Rx<string | null>(null);
  /** Test mode only: the manual Stripe account id form. */
  readonly stripeTestMode = new Rx(false);
  readonly attachAccountId = new Rx("");
  readonly attaching = new Rx(false);
  /** Keyed by provider, so a Stripe failure cannot read as Shopify's. */
  readonly actionError = new Rx<{ providerKey: string; message: string } | null>(null);
}

export abstract class ProvidersSectionActions {
  abstract connect(providerKey: string): Promise<void>;
  abstract openDashboard(): Promise<void>;
  abstract setAttachAccountId(value: string): void;
  abstract attachAccount(): Promise<void>;
  abstract refresh(providerKey: string): Promise<void>;
  abstract startDisconnect(providerKey: string): void;
  abstract cancelDisconnect(): void;
  abstract disconnect(providerKey: string): Promise<void>;
  abstract retry(): void;
}
